import styles from "./insights-cover.module.css";
import CTAinsightComponent from "../CTAinsight/cta-insight";
import coverImg from "../../../images/_finais/insights-cover_compress.webp";
import { IPostInsight } from "../../../interfaces/insightPost";

interface IProps {
  onHandlePages: any;
  postInfo?: IPostInsight;
}

const InsightsCover = ({ onHandlePages, postInfo }: IProps) => {
  return (
    <main className={styles.mainCover}>
      <section className={styles.cover_section}>
        <CTAinsightComponent
          subTitle="Confira nosso último Insight:"
          title={postInfo?.title || ""}
          servicoText={postInfo?.description}
          onHandlePages={onHandlePages}
          id={postInfo?._id}
        />
        <img
          className={styles.coverImg}
          src={coverImg}
          alt="Cover da página Home."
          loading="lazy"
        />
      </section>
    </main>
  );
};

export default InsightsCover;
